/**
 * @description headerとmenu関連
 */

import { isSumaho } from '../common/isSumaho';

export const setHeader = () => {
  toggleMenu();
  setFixed();
  spMenu();
  toggleReserveMenu();
  setLink();
  menuAnchor();
  $('main').prepend($('.header').clone(true));
  $('main').find('.header').addClass('is-clone');
};

const toggleMenu = () => {
  $('.js-toggle-menu').on('click', (e) => {
    $('.menu').fadeToggle(300);
    $('.js-toggle-menu').removeClass('active');
    $(e.target).toggleClass('active');
  });
};

const setFixed = () => {
  $(window).on('scroll', () => {
    //スマホ時はheader abs
    if (isSumaho()) return;
    const pos: number = $(window).scrollTop() || 0;
    if (pos > 150) {
      $('.header.is-clone').addClass('is-fixed');
      $('.gnav').addClass('on');
    } else {
      $('.header.is-clone').removeClass('is-fixed');
      $('.gnav').removeClass('on');
    }
  });
};

//spメニューアコーディオン
const spMenu = () => {
  $('.toggleIcon').on('click', function () {
    if (!isSumaho()) return;
    const box = $(this).find('.sub');
    $(box).slideToggle();
    if ($(this).hasClass('close')) {
      $(this).removeClass('close');
    } else {
      $(this).addClass('close');
    }
  });
};

const toggleReserveMenu = () => {
  $('.js-toggle-reserveMenu').on('click', () => {
    $('.reserveMenu').fadeToggle(500);
    $('body').toggleClass('is-lock');
  });
};

//客室リンク設定用
const setLink = () => {
  $('.js-toggle-menu').on('click', (e) => {
    $('.js-menu-anchor')
      .find('a')
      .each(function (i, e) {
        const url = $(e).attr('href')!;
        if (location.href.match(/room/)) {
          return;
        }
        if (location.href.match(url.substring(0, url.indexOf('#')))) {
          let newUrl = url.substring(0, url.indexOf('#'));
          newUrl = url.replace(newUrl, '');
          $(e).attr('href', newUrl);
          if (i !== 0) $(e).addClass('js-notfade');
        }
      });
  });
};

const menuAnchor = () => {
  $('.js-menu-anchor')
    .find('a')
    .on('click', (e) => {
      $('.menu').fadeOut(300);
      $('.js-toggle-menu').removeClass('active');
      const me = $(e.currentTarget);
      if (me.hasClass('noscroll')) return false;
      ankerScroll(me.attr('href') ?? '');
    });
};

// アンカー位置にページスクロールさせる
function ankerScroll(href: string): void {
  let speed: number = 400;
  let target: JQuery = $(href == '#' || href == undefined || href == '' ? 'html' : href);
  let fix: number = $('.header').outerHeight() ?? 0;
  let top: number = (target.offset()?.top ?? 0) - fix;
  $('body,html').animate({ scrollTop: top }, speed, 'swing');
}
